import script from "./WaterDiagram.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaterDiagram.vue?vue&type=script&setup=true&lang=ts"

import "./WaterDiagram.vue?vue&type=style&index=0&id=2d708e2c&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d708e2c"]])

export default __exports__